import formatIntegerBySpace from '../../../../helpers/formatters/format-integer-by-space'
import outputCalculatedValue from '../../../../helpers/formatters/output-calculated-value'
import CalculationToolingCostCell from '../../components/tooling-cost-cell/tooling-cost-cell'
import { renderCalcPos, onAnyStandardCell } from '../../helpers/helpers'
import type { CalculationColumn } from '../../types/column-types'

export const calculatedConsumablesColumns: CalculationColumn[] = [
    {
        dataIndex: ['calculated', 'consumables'],
        title: 'Стоимость расходников и оборудования',
        // @ts-ignore
        children: [
            {
                dataIndex: ['calculated', 'paintCost'],
                title: 'Краска',
                width: 80,
                onCell: onAnyStandardCell,
                render: renderCalcPos(r =>
                    formatIntegerBySpace(Math.round((r.calculated?.paintCost || 0) * 10) / 10)
                ),
            },
            {
                dataIndex: ['calculated', 'stampCost'],
                title: 'Штамп',
                width: 120,
                onCell: onAnyStandardCell,
                render: renderCalcPos(r => (
                    <CalculationToolingCostCell
                        position={r}
                        kind='stamp'
                        value={outputCalculatedValue(r.calculated?.stampCost || 0)}
                    />
                )),
            },
            {
                dataIndex: ['calculated', 'formsCost'],
                title: 'Формы',
                width: 120,
                onCell: onAnyStandardCell,
                render: renderCalcPos(r => (
                    <CalculationToolingCostCell
                        position={r}
                        kind='forms'
                        value={formatIntegerBySpace(
                            Math.round((r.calculated?.formsCost || 0) * 10) / 10
                        )}
                    />
                )),
            },
        ],
    },
]
